import React, { useEffect, useState } from 'react'

// components
import OutlineButton from 'components/Button/OutlineButton'
import GradientButton from 'components/Button/GradientButton'

// resources
import PlusIcon from 'assets/icons/plus-icon-8x8.svg?component'
import MinusIcon from 'assets/icons/minus-icon-8x8.svg?component'
import CloseIcon from 'assets/icons/close-white-13x13.svg?component'

// styles
import styles from './index.module.scss'

const MobileProfileFilter = props => {
  const { listingStatus, tokenType, onClose, onFilter } = props

  const [listingStatusList, setListingStatusList] = useState<any>(listingStatus)
  const [tokenTypeList, setTokenTypeList] = useState<any>(tokenType)
  const [showListingStatus, setShowListingStatus] = useState(true)
  const [showTokenType, setShowTokenType] = useState(true)

  const handleSelectListingStatus = index => {
    let array = [...listingStatusList]
    array.map(item => {
      item.checked = false
    })
    array[index].checked = true
    setListingStatusList(array)
  }

  const handleSelectTokenType = index => {
    let array = [...tokenTypeList]
    array.map(item => {
      item.checked = false
    })
    array[index].checked = true
    setTokenTypeList(array)
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.header}>
          <div className={styles.headerTitle}>Filters</div>
          <div className="w-[35px] h-[35px] flex items-center justify-center" onClick={() => onClose()}>
            <CloseIcon />
          </div>
        </div>

        <div className="g-container mt-[30px]">
          {/* Listing Status */}
          <div className="w-full">
            <div
              className="w-full flex justify-between items-start gap-[15px]"
              onClick={() => setShowListingStatus(!showListingStatus)}
            >
              <div className={`${styles.showListing}`}>Listing Status</div>
              <div className="w-[16px] h-[16px] flex items-center justify-center">
                {showListingStatus ? <MinusIcon /> : <PlusIcon />}
              </div>
            </div>

            <div className={styles.descBorder} />

            {showListingStatus && (
              <div className="mt-15px">
                {listingStatusList.map((item, index) => (
                  <div id={`check-label-${index}`} key={index} className="flex justify-between mt-[15px]">
                    <label
                      className={`${styles.checkmark}`}
                      onClick={() => {
                        handleSelectListingStatus(index)
                      }}
                    >
                      {item.name}
                    </label>
                    <input
                      className={`${styles.checkbox}`}
                      type="checkbox"
                      id={item.id}
                      checked={item.checked}
                      onChange={() => {
                        handleSelectListingStatus(index)
                      }}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Token Type */}
          <div className="w-full mt-[30px]">
            <div
              className="w-full flex justify-between items-start gap-[15px]"
              onClick={() => setShowTokenType(!showTokenType)}
            >
              <div className={`${styles.showListing}`}>Token Type</div>
              <div className="w-[16px] h-[16px] flex items-center justify-center">
                {showTokenType ? <MinusIcon /> : <PlusIcon />}
              </div>
            </div>

            <div className={styles.descBorder} />

            {showTokenType && (
              <div className="mt-15px">
                {tokenTypeList.map((item, index) => (
                  <div id={`check-label-${index}`} key={index} className="flex justify-between mt-[15px]">
                    <label
                      className={`${styles.checkmark}`}
                      onClick={() => {
                        handleSelectTokenType(index)
                      }}
                    >
                      {item.name}
                    </label>
                    <input
                      className={`${styles.checkbox}`}
                      type="checkbox"
                      id={item.id}
                      checked={item.checked}
                      onChange={() => {
                        handleSelectTokenType(index)
                      }}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className={styles.bottomArea}>
        <div className="w-[94px]">
          <OutlineButton label="Cancel" onClick={() => onClose()} fontSize={16} fullWidth height={43} />
        </div>
        <div className="w-[94px]">
          <GradientButton
            label="Apply"
            height={43}
            fontSize={16}
            onClick={() =>
              onFilter({
                listingStatus: listingStatusList,
                tokenType: tokenTypeList,
              })
            }
            fullWidth
          />
        </div>
      </div>
    </div>
  )
}

export default MobileProfileFilter
